"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _themes = require("../themes");

var _themes2 = require("./themes");

var _styled2 = require("./styled");

var _OverflowContainer = _interopRequireDefault(require("./OverflowContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: These components cannot live in styled.js due to circular dependency
// issues with OverflowContainer
var ThemedOverflowContainer = (0, _themes.themed)(_OverflowContainer.default)(function (_ref) {
  var baseTheme = _ref.theme;
  return (0, _themes.mapComponentThemes)({
    name: 'OverflowContainerWithShadows',
    theme: (0, _themes2.overflowContainerWithShadowsTheme)(baseTheme)
  }, {
    name: 'OverflowContainer',
    theme: {}
  }, baseTheme);
});

var _default = (
/*#__PURE__*/
0, _styledBase.default)(ThemedOverflowContainer, {
  target: "e5t3hk80"
})(_styled2.getScrollerStyles);

exports.default = _default;